import React from 'react';
import ReactDOM from 'react-dom/client';

// Design system first: rules (ojee-ui) then tokens (mono theme), so the
// theme wins wherever it redefines a value. app.css comes last because it
// layers the two page layouts on top of both.
import './design/fonts.css';
import './design/ojee-ui.css';
import './design/mono.css';
import './index.css';
import './styles/app.css';

import App from './App';

// ojee-ui's app shell (flex column, sticky nav, growing .wrap) is scoped to
// body.app — set it before first paint so nothing reflows.
document.body.classList.add('app');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
